(function () {
  const initSection = (section) => {
    if (!section || section.dataset.babiesFeaturedProductsInitialized === "true") {
      return;
    }

    section.dataset.babiesFeaturedProductsInitialized = "true";

    const tabs = Array.from(section.querySelectorAll("[data-tab-trigger]"));
    const panes = Array.from(section.querySelectorAll("[data-tab-pane]"));
    const paneSwipers = new Map();
    const showArrows = section.dataset.showArrows === "true";

    const tabsSwiperEl = section.querySelector(".babies-featured-products__tabs-swiper");
    if (tabsSwiperEl) {
      new Swiper(tabsSwiperEl, {
        slidesPerView: "auto",
        spaceBetween: 8,
        watchOverflow: true,
        breakpoints: {
          990: {
            spaceBetween: 12
          }
        },
      });
    }

    const ensurePaneSwiper = (pane) => {
      if (!pane) {
        return;
      }

      const paneId = pane.dataset.tabPane;
      if (paneSwipers.has(paneId)) {
        return;
      }

      const swiperEl = pane.querySelector(".babies-featured-products__products-swiper");
      if (!swiperEl) {
        return;
      }

      let arrowsParams = {};
      if (showArrows) {
        arrowsParams = {
          navigation: {
            nextEl: pane.querySelector(".swiper-button-next"),
            prevEl: pane.querySelector(".swiper-button-prev")
          }
        };
      }

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        breakpoints: {
          990: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },
        ...arrowsParams
      });

      let clearDraggingTimer = null;
      let isPointerHeld = false;
      let hasDragged = false;
      const setDraggingState = (isDragging, releaseDelay = 0) => {
        if (clearDraggingTimer) {
          clearTimeout(clearDraggingTimer);
          clearDraggingTimer = null;
        }

        if (isDragging) {
          section.classList.add("is-dragging");
          return;
        }

        if (releaseDelay > 0) {
          clearDraggingTimer = setTimeout(() => {
            section.classList.remove("is-dragging");
            clearDraggingTimer = null;
          }, releaseDelay);
          return;
        }

        section.classList.remove("is-dragging");
      };

      swiper.on("sliderFirstMove", () => {
        hasDragged = true;
        setDraggingState(true);
      });
      swiper.on("sliderMove", () => {
        hasDragged = true;
        setDraggingState(true);
      });
      swiper.on("touchMove", () => {
        hasDragged = true;
        setDraggingState(true);
      });
      swiper.on("touchEnd", () => {
        if (!isPointerHeld) {
          setDraggingState(false, 120);
        }
      });
      swiper.on("transitionEnd", () => {
        if (!isPointerHeld) {
          setDraggingState(false, 120);
        }
      });
      swiper.on("fromEdge", () => {
        if (!isPointerHeld) {
          setDraggingState(false, 120);
        }
      });

      const clearDraggingState = () => {
        isPointerHeld = false;
        if (hasDragged) {
          setDraggingState(false, 120);
        } else {
          setDraggingState(false);
        }
        hasDragged = false;
      };

      const isInteractiveTarget = (target) => {
        return !!target.closest("button, input, select, textarea, label, modal-opener, .quick-add, .quick-add-media");
      };

      const onPointerDown = (event) => {
        if (event.pointerType === "mouse" && event.button !== 0) {
          return;
        }

        isPointerHeld = true;
        hasDragged = false;

        if (!isInteractiveTarget(event.target)) {
          setDraggingState(false);
        }
      };

      swiperEl.addEventListener("pointerdown", onPointerDown);
      swiperEl.addEventListener("pointerup", clearDraggingState);
      swiperEl.addEventListener("pointercancel", clearDraggingState);

      swiperEl.addEventListener("mousedown", (event) => {
        if (event.button !== 0) {
          return;
        }

        isPointerHeld = true;
        hasDragged = false;

        if (!isInteractiveTarget(event.target)) {
          setDraggingState(false);
        }
      });
      swiperEl.addEventListener("mouseup", clearDraggingState);

      window.addEventListener("pointerup", clearDraggingState);
      window.addEventListener("mouseup", clearDraggingState);
      window.addEventListener("blur", clearDraggingState);

      paneSwipers.set(paneId, swiper);
    };

    const activateTab = (tabId) => {
      let activePane = null;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.tabTrigger === tabId;
        tab.classList.toggle("is-active", isActive);
      });

      panes.forEach((pane) => {
        const isActive = pane.dataset.tabPane === tabId;
        pane.classList.toggle("is-active", isActive);
        if (isActive) {
          activePane = pane;
        }
      });

      ensurePaneSwiper(activePane);

      if (activePane) {
        const activeSwiper = paneSwipers.get(activePane.dataset.tabPane);
        if (activeSwiper) {
          activeSwiper.update();
        }
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        activateTab(tab.dataset.tabTrigger);
      });

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          activateTab(tab.dataset.tabTrigger);
        }
      });
    });

    if (tabs.length > 0) {
      activateTab(tabs[0].dataset.tabTrigger);
    }
  };

  const initAllSections = () => {
    document.querySelectorAll(".babies-featured-products").forEach((section) => {
      initSection(section);
    });
  };

  document.addEventListener("DOMContentLoaded", initAllSections);

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".babies-featured-products");
    initSection(section);
  });
})();
